import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { supabaseClient } from "@/lib/supabase/client"
import { PostCard } from "@/components/post/PostCard"
import { FeedSkeleton } from "@/components/feed/FeedSkeleton"
import { useAuth } from "@/components/layout/AuthProvider"

export default function TrendingPage() {
  const { supabaseUser } = useAuth()
  const [posts, setPosts] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabaseClient.from("posts")
      .select("*, users(id,username,display_name,avatar_url,is_verified), post_topics(topics(id,name,slug))")
      .eq("status", "published")
      .order("vote_count", { ascending: false })
      .limit(30)
      .then(({ data }) => { setPosts(data || []); setLoading(false) })
  }, [])

  return (
    <div className="container-narrow py-4">
      <div className="mb-6">
        <h1 className="font-bold text-xl">Trending</h1>
        <p className="text-text-muted text-sm mt-1">Most popular posts right now</p>
      </div>
      {loading ? <FeedSkeleton /> : posts.map(post => (
        <PostCard key={post.id} post={post} userId={supabaseUser?.id || null} />
      ))}
      {!loading && posts.length === 0 && (
        <div className="text-center py-16 text-text-muted">No trending posts yet</div>
      )}
    </div>
  )
}